import request from '@/plugins/axios'

// 商家列表（下拉筛选）
export const apiInventoryShopList = (params?: any) => request.get('/goods.inventory/shopList', { params })

// 进销存概览
export const apiInventoryOverview = (params?: any) => request.get('/goods.inventory/overview', { params })

// 库存管理
export const apiInventoryStockLists = (params: any) => request.get('/goods.inventory_stock/lists', { params })
export const apiInventoryStockAdjust = (data: any) => request.post('/goods.inventory_stock/adjust', data)
export const apiInventoryStockBatchAdjust = (data: any) => request.post('/goods.inventory_stock/batchAdjust', data)
export const apiInventoryStockDetail = (params: any) => request.get('/goods.inventory_stock/detail', { params })
export const apiInventoryStockLogs = (params: any) => request.get('/goods.inventory_stock/logs', { params })
export const apiInventoryStockStatistics = (params?: any) => request.get('/goods.inventory_stock/statistics', { params })
export const apiInventoryStockSetWarning = (data: any) => request.post('/goods.inventory_stock/setWarning', data)

// 进货管理
export const apiInventoryPurchaseLists = (params: any) => request.get('/goods.inventory_purchase/lists', { params })
export const apiInventoryPurchaseAdd = (data: any) => request.post('/goods.inventory_purchase/add', data)
export const apiInventoryPurchaseEdit = (data: any) => request.post('/goods.inventory_purchase/edit', data)
export const apiInventoryPurchaseDetail = (params: any) => request.get('/goods.inventory_purchase/detail', { params })
export const apiInventoryPurchaseAudit = (data: any) => request.post('/goods.inventory_purchase/audit', data)
export const apiInventoryPurchaseDel = (data: any) => request.post('/goods.inventory_purchase/del', data)
export const apiInventoryPurchaseStatistics = (params?: any) => request.get('/goods.inventory_purchase/statistics', { params })

// 销售出库
export const apiInventorySalesLists = (params: any) => request.get('/goods.inventory_sales/lists', { params })
export const apiInventorySalesDetail = (params: any) => request.get('/goods.inventory_sales/detail', { params })
export const apiInventorySalesStatistics = (params?: any) => request.get('/goods.inventory_sales/statistics', { params })

// 库存盘点
export const apiInventoryStocktakingLists = (params: any) => request.get('/goods.inventory_stocktaking/lists', { params })
export const apiInventoryStocktakingAdd = (data: any) => request.post('/goods.inventory_stocktaking/add', data)
export const apiInventoryStocktakingEdit = (data: any) => request.post('/goods.inventory_stocktaking/edit', data)
export const apiInventoryStocktakingDetail = (params: any) => request.get('/goods.inventory_stocktaking/detail', { params })
export const apiInventoryStocktakingFinish = (data: any) => request.post('/goods.inventory_stocktaking/finish', data)
export const apiInventoryStocktakingDel = (data: any) => request.post('/goods.inventory_stocktaking/del', data)
export const apiInventoryStocktakingAnalysis = (params: any) => request.get('/goods.inventory_stocktaking/analysis', { params })
